module.exports = __webpack_public_path__ + "pc/img/ico-e-white.b60ee01e.svg";